module.exports = __webpack_public_path__ + "img/data4.56e5ca2f.png";